import React from 'react'
import Card from '../card/card'
import { t } from '../../../utils/i18n'
import { useFavorites } from '../../../context/FavoritesContext'
import { AppList } from '../../../pages/overview'
import './category-card.scss'

type CategoryCardType = {
  appList: AppList | null
  allowedApps?: string[]
  isLoading?: boolean
}
export const CategoryCard = ({ appList, allowedApps, isLoading }: CategoryCardType) => {
  const { favorites } = useFavorites()

  const renderLoadingState = () => (
    <div className="category-pulsating">
      {[...Array(3)].map((_, i) => {
        return (
          <div className="category-card" key={i}>
            <div className="category-title">
              <h3></h3>
            </div>
            <p className="heading-description"></p>
            <div className="card-group">
              {[...Array(2)].map((_, i) => (
                <div className="card" key={i}></div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )

  return isLoading ? (
    renderLoadingState()
  ) : (
    <section className="category">
      {appList?.data?.map((app, i) => {
        return (
          <div className="category-card" key={i}>
            <div className="category-title">
              <h3>{app?.name}</h3>
            </div>
            <p className="heading-description">{app?.description}</p>
            <div className="card-group">
              {app?.apps ? (
                app?.apps.map((a, j) => {
                  const isFav = favorites?.includes(a?.appSysId)
                  return (
                    <Card
                      key={j}
                      title={a?.name}
                      description={a?.description}
                      isFavorite={isFav}
                      icon={a?.signedUrlForLogo}
                      allowedApps={allowedApps}
                      appSysId={a?.appSysId}
                      link={a?.landingPageUrl}
                    />
                  )
                })
              ) : (
                <p className="body-sm">{t('no.apps.in.category')}</p>
              )}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default CategoryCard
